import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const GetProductsQuery = gql`
  query products($domain: String!, $search: String, $categoryId: String) {
    minimalProducts(domain: $domain, title_contains: $search, categoryId: $categoryId) {
      id
      hideForCountry
      variants {
        id
        definition
        sku
        productId
      }
    }

    productsCategories(categoryId: $categoryId) {
      productId,
      categoryId
      priority
    }
  }
`;

const DeleteProductMutation = gql`
  mutation delete($id: String!) {
    deleteProduct(id: $id) {
      id
    }
  }
`;

const updateProductPriority = gql`
  mutation updateProductPriority($productId: String!, $categoryId: String!, $priority: Int!) {
    updateProductPriority(productId: $productId, categoryId: $categoryId, priority: $priority) {
      productId
      categoryId
      priority
    }
  }
`;

interface IInputProps {
  children?: any;
  search?: string;
  categoryId?: string;
  productId?: string;
  priority?: number;
  domain: string;
}

interface Response {
  data: any;
}

class ProductsQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  static defaultProps = {
    search: ''
  };

  public render() {
    // console.log('fetching data - search variants query', this.props);
    const { minimalProducts, productsCategories, deleteProduct, updateProductPriority }: any = this.props;
    return this.props.children({
      minimalProducts,
      productsCategories,
      deleteProduct,
      updateProductPriority
    });
  }
}

// # variants(where: { attributeValues_some: { id_in: $filterValues } }) {

export default compose(
  graphql<IInputProps, Response>(GetProductsQuery, {
    name: 'minimalProducts',
    options: props => ({
      variables: {
        search: props.search || '',
        categoryId: props.categoryId ? props.categoryId : undefined,
        domain: props.domain
      },
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true
    })
  }),
  graphql<IInputProps, Response>(GetProductsQuery, {
    name: 'productsCategories'
  }),
  graphql<IInputProps, Response>(DeleteProductMutation, {
    name: 'deleteProduct'
  }),
  graphql<IInputProps, Response>(updateProductPriority, {
    name: 'updateProductPriority',
    options: props => ({
      variables: {
        productId: props.productId,
        categoryId: props.categoryId,
        priority: props.priority,
      }
    })
  })
)(ProductsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Products/SearchCatalog.tsx